// Rôle requis : ADMIN_TIMESHEET
// Ce hook permet à un administrateur de récupérer le fichier PDF signé par le client.
// Seuls les utilisateurs ayant le rôle ADMIN_TIMESHEET peuvent accéder à cette requête.

import { useAuthContext } from '@/context/AuthContext';
import { useState } from 'react';
import {userManager} from '@/components/authentication/keycloak.js';

function useSignedTimesheet() {
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const requestSignedTimesheet = async (timesheetUuid, year, month) => {
        const apiUrl = `${window.ENV.BACKEND_URL}/api/secured/users/timesheet/signedTimesheet/${timesheetUuid}`;
        setLoading(true);
        const user = await userManager.getUser();
        try {
            const response = await fetch(apiUrl, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${user.access_token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const blob = await response.blob();
            const url = URL.createObjectURL(blob);
            // console.log("blob file timesheet ", blob, url)

            setData({ url, type: blob.type });
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return { requestSignedTimesheet, data, loading, error };
}

export default useSignedTimesheet;
